import Request, { SimpleResponse } from './Request';
import { IUser } from './User';

export interface AuthResponse extends SimpleResponse {
    token: string;
    user: IUser;
}

class Login {
    static Authentication = (data: IUser): AuthResponse => { return Request.DoPost('login/authenticate', data) as unknown as AuthResponse; };
    static ForgotPassword = (data: IUser): SimpleResponse => { return Request.DoPost('login/forgotpassword', data) as unknown as SimpleResponse; };
    static ChangePassword = (data: IUser): SimpleResponse => { return Request.DoPost('login/changepassword', data) as unknown as SimpleResponse; };
    static Logout = (): AuthResponse => { return Request.DoPost('login/logout', {}) as unknown as AuthResponse; };
}

export default Login;